module.exports = __webpack_public_path__ + "static/lepaCH-8a2d3c5dbb7a998eb408f2d26f274340.png";